var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var SubscriptionFeature = /** @class */ (function (_super) {
    __extends(SubscriptionFeature, _super);
    function SubscriptionFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all the subscription features
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/subscription-feature/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SubscriptionFeature.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Get all the subscription features
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/subscription-feature/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    SubscriptionFeature.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/subscription-features',
        });
    };
    SubscriptionFeature.TYPE = 'subscription_feature';
    return SubscriptionFeature;
}(BaseResource));
export default SubscriptionFeature;
//# sourceMappingURL=SubscriptionFeature.js.map